import { SelectWorkflowComponent } from './common/selectcomponent'
import { Provider, WorkflowComponentCodeParams, WorkflowComponentParamType } from '../types'
import dedent from 'ts-dedent'

class SelectExpression extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.selectexpression',
        group: 'Data Preparation',
        title: 'Create Column',
        description: `
      This component creates a new table with an additional column computed using an expression.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'column',
          type: WorkflowComponentParamType.String,
          title: 'Name for new column',
          placeholder: 'E.g.: distance_in_meters',
          validation: '^[a-zA-Z_][a-zA-Z0-9_]*$',
          allowExpressions: false
        },
        {
          name: 'expression',
          type: WorkflowComponentParamType.StringSql,
          title: 'Expression',
          placeholder: 'E.g.: distance_in_km * 1000'
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */ *,
                ${params.expression} AS ${params.column}
              FROM ${connection.quoteName(params.source as string)}`
    } else {
      return dedent`SELECT *,
                ${params.expression} AS ${params.column}
              FROM ${connection.quoteName(params.source as string)}`
    }
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { SelectExpression }
